const PANEL_PAD = 12;

export function measureTargetRect(targetEl) {
  if (!targetEl || typeof targetEl.getBoundingClientRect !== "function") {
    return null;
  }
  const rect = targetEl.getBoundingClientRect();
  if (rect.width < 4 || rect.height < 4) {
    return null;
  }
  return {
    top: rect.top,
    left: rect.left,
    right: rect.right,
    bottom: rect.bottom,
    width: rect.width,
    height: rect.height,
  };
}

export function buildSpotlightClipPath(rect, pad = PANEL_PAD) {
  if (!rect || typeof window === "undefined") {
    return undefined;
  }
  const x1 = Math.max(0, rect.left - pad);
  const y1 = Math.max(0, rect.top - pad);
  const x2 = Math.min(window.innerWidth, rect.right + pad);
  const y2 = Math.min(window.innerHeight, rect.bottom + pad);
  return `polygon(evenodd, 0% 0%, 100% 0%, 100% 100%, 0% 100%, 0% 0%, ${x1}px ${y1}px, ${x2}px ${y1}px, ${x2}px ${y2}px, ${x1}px ${y2}px, ${x1}px ${y1}px)`;
}

export function computeCoachMarkBalloonStyle(rect, balloonWidth = 280) {
  if (!rect || typeof window === "undefined") {
    return { top: 16, left: 16, placement: "bottom" };
  }
  const gap = 12;
  const spaceRight = window.innerWidth - rect.right;
  const spaceLeft = rect.left;
  const spaceBottom = window.innerHeight - rect.bottom;

  if (spaceRight >= balloonWidth + gap + 8) {
    return {
      top: Math.max(12, rect.top + 16),
      left: rect.right + gap,
      placement: "right",
    };
  }
  if (spaceLeft >= balloonWidth + gap + 8) {
    return {
      top: Math.max(12, rect.top + 16),
      left: Math.max(12, rect.left - balloonWidth - gap),
      placement: "left",
    };
  }
  if (spaceBottom >= 120) {
    return {
      top: rect.bottom + gap,
      left: Math.max(12, Math.min(rect.left, window.innerWidth - balloonWidth - 12)),
      placement: "bottom",
    };
  }
  return {
    top: Math.max(12, rect.top - gap - 96),
    left: Math.max(12, Math.min(rect.left, window.innerWidth - balloonWidth - 12)),
    placement: "top",
  };
}

export const COACH_MARK_ANIM_MS = 300;
export const MOBILE_BUILDER_BREAKPOINT = 768;
